import styled from 'styled-components';
import { FlexibleButtonIconModel } from '@services/flexible_component/mod';
import { ExternalSvg } from '@components/external_svg.component';
import { Routeable } from './_flexible_identifier_routeable.component';
import { Text, VStack } from '@visiba-cortex/react-ui-std';
import { FONT_VARIANT } from '../../constants';
import { theme } from '@services/theme.service/theme';
import { rem } from '@visiba/std';
import { Icon, IconType } from '@components/icon.component';
import { tokens } from '@cellula/react-theme-patient';

interface Props {
	component: FlexibleButtonIconModel;
	__TEMP__on_OPW_WebContentButton_proxy_invoke?: (flexibleIdentifierData: {
		url: string;
		openUrlWith: string;
		requiresAuthentication: boolean;
	}) => void;
}

const elements = {
	button: styled.div`
		display: flex;
		align-items: center;
		width: 100%;
		background: ${theme.primary};
		border-radius: ${rem(10)};
		min-height: ${rem(64)};
		padding-top: ${tokens.spacing.x2};
		padding-bottom: ${tokens.spacing.x2};
		color: #fff;
	`,
	icon: styled.div`
		margin: 0 ${rem(20)};
		width: ${rem(24)};
		height: ${rem(24)};
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: ${rem(24)};
		color: #fff;
		flex-shrink: 0;
	`,
};

export function FlexibleButtonIcon({ component, __TEMP__on_OPW_WebContentButton_proxy_invoke, ...rest }: Props): JSX.Element {
	return (
		<Routeable
			url={component.url}
			requiresAuthentication={component.requiresAuthentication}
			openWith={component.openUrlWith}
			__TEMP__on_OPW_WebContentButton_proxy_invoke={__TEMP__on_OPW_WebContentButton_proxy_invoke}
			{...rest}
		>
			<elements.button data-testid='FlexibleButtonIcon'>
				<elements.icon>
					{component.icon?.type == 'local' ? (
						<Icon type={component.icon.origin as IconType} />
					) : component.icon?.type == 'svgUrl' ? (
						<ExternalSvg imgSrc={component.icon.origin} size={24} />
					) : component.icon?.type == 'pngUrl' ? (
						<img src={component.icon.origin} height={24} alt='' />
					) : null}
				</elements.icon>

				<VStack fluid={false}>
					<Text font={FONT_VARIANT.LARGE_BODY}>{component.title}</Text>
					{component.subtitle ? <Text font={FONT_VARIANT.BODY}>{component.subtitle}</Text> : null}
				</VStack>
			</elements.button>
		</Routeable>
	);
}
